import React from 'react';
import styled from 'styled-components';

const StyledContainer = styled.div`
  width: 100%;
  max-width: ${props => props.small ? '600px' : '1200px'};
  margin: 0 auto;
  padding: 0 1.5rem;
  
  @media (max-width: 992px) {
    max-width: ${props => props.small ? '500px' : '900px'};
    padding: 0 1.25rem;
  }
  
  @media (max-width: 768px) {
    max-width: ${props => props.small ? '450px' : '100%'};
    padding: 0 1rem;
  }
  
  @media (max-width: 480px) {
    padding: 0 0.75rem;
  }
`;

const Container = ({ children, small, ...props }) => {
  return (
    <StyledContainer small={small} {...props}>
      {children}
    </StyledContainer>
  );
};

export default Container; 